import type { VfConfig } from '#types/config/components/vf'

export default {
  showErrorIcon: true,
  showSuccessIcon: true
} satisfies VfConfig['textarea']
